module.exports = __webpack_public_path__ + "img/ic-flag-brazil.515f5ce8.svg";